class HeaderScroll {
  constructor(selector) {
    this.root = document.querySelector(selector);

    if (!this.root) {
      return;
    }

    this.header = this.root.querySelector('.c-header');

    if (!this.header) {
      return;
    }

    this.threshold = 200;
    this.mq = window.matchMedia('(max-width: 767px)');
    this.onScroll = this.onScroll.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);

    this.mq.addEventListener('change', this.onMediaChange);
    window.addEventListener('scroll', this.onScroll, { passive: true });

    this.update();
  }

  update() {
    if (!this.mq.matches) {
      this.header.classList.remove('is-scrolled');
      return;
    }

    this.header.classList.toggle('is-scrolled', window.scrollY >= this.threshold);
  }

  onScroll() {
    this.update();
  }

  onMediaChange() {
    this.update();
  }
}
